import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import './App.css';
import  BaseComponent  from './router/Router';
// import TimeoutModal from './TimeoutModal';

function App() {

  
  // var userDetails = localStorage.getItem('argus_user') !== null ? localStorage.getItem('argus_user') : null;
  // var token =  userDetails !== null && JSON.parse(userDetails).token !== null ? JSON.parse(userDetails).token : "";
  // const [isAuthenticated, setAuth] = useState(false);
  // const navigate = useNavigate();

  // useEffect(() =>{
  //     if(token !== ""){
  //       setAuth(true);
  //     }
  //      // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[userDetails]);


  // const logOut = () => {
  //   setAuth(!isAuthenticated);
  //   localStorage.removeItem("argus_user");
  //   localStorage.clear();
  //   navigate("/");
  // };

  return (
    <div data-testid="baseComponent" className="App">
      <BaseComponent/>
       {/* <TimeoutModal isAuthenticated={isAuthenticated} logOut={logOut} /> */}
    </div>
  );
}

export default App;
